import * as React from "react";
import { Tooltip, OverlayTrigger, Glyphicon } from "react-bootstrap";
import { IconoAccion } from "../modelo/IconoAccion";

export default class AccionAdministracion extends React.Component<AccionAdministracionProps> {

    render() {
        const { texto, icono } = this.props;

        const tooltip = (
            <Tooltip id="tooltip" className="tooltip-pos" arrowOffsetTop={20}>{texto}</Tooltip>
        );

        return (
            <OverlayTrigger placement="top" overlay={tooltip}>
                <span className="icons-table">
                    <Glyphicon glyph={icono} />
                </span>
            </OverlayTrigger>
        );
    }
}

interface AccionAdministracionProps {
    texto: string,
    icono: IconoAccion
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/componentes/AccionAdministracion.tsx